export type PagedListJson = {
  total_count: number;
  current_page: number;
  total_pages: number;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entries: any[];
};

export class PagedList<T> {
  totalCount: number;
  currentPage: number;
  totalPages: number;
  entries: T[];

  constructor(totalCount: number, currentPage: number, totalPages: number, entries: T[]) {
    this.totalCount = totalCount;
    this.currentPage = currentPage;
    this.totalPages = totalPages;
    this.entries = entries;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static empty(): PagedList<any> {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return new PagedList<any>(0, 1, 1, []);
  }

  static fromJson<T>(json: PagedListJson): PagedList<T> {
    return new PagedList<T>(json.total_count, json.current_page, json.total_pages, json.entries);
  }
}
